<template>
  <div class="col-12">
    <div class="card survey-panel">
      <div class="card-body">
        <div class="row g-4">
          <div class="col-12">
            <span class="badge text-bg-light border mb-3 px-3 py-2">Schritt 2</span>
            <h2 class="h3 card-title mb-2">Was möchten Sie vermarkten?</h2>
            <p class="text-secondary mb-0">
              Wählen Sie den Bereich, der am besten zu Ihrem Haupt-Eintrag passt. Danach folgen die passenden Detailfragen.
            </p>
          </div>
          <div class="col-12 col-lg-7">
            <label for="objekttyp" class="form-label fw-semibold">Objekttyp</label>
            <Field as="select" v-model="surveyStore.data.objekttyp" id="objekttyp" name="objekttyp"
                   class="form-select" :class="{'is-invalid': errors.objekttyp}">
<!--           Careful when changing keys!!!11 Some keys might be used for filtering etc-->
              <option value="">Bitte wählen</option>
              <option value="unterkunft">Unterkunft (FeHa, FeWo, Hotel, Camping, ...)</option>
              <option value="essen_trinken">Restaurant (Gaststätte, Café, Bar)</option>
              <option value="freizeitanbieter">Freizeitanbieter (Verleih, Touren, Reiten, Sport...)</option>
              <option value="veranstaltung">Veranstaltung (Konzert, Location, Fest, Tagung...)</option>
              <option value="kunst_kultur">Sehenswürdigkeit, Kunst und Kultur</option>
              <option value="nichts">nichts Passendes dabei</option> <!-- TODO: implement me! -->
            </Field>
            <div v-if="errors.objekttyp" class="invalid-feedback">
              {{ errors.objekttyp }}
            </div>
          </div>
          <div class="col-12 col-lg-5" v-if="surveyStore.currentConfig.tipp">
            <div class="alert alert-primary border-0 h-100 mb-0">
              <div class="fw-semibold mb-2">Hinweis</div>
              <div class="small text-body mb-0" v-html="surveyStore.currentConfig.tipp"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "@/stores/survey";
import {Field} from 'vee-validate';

export default {
  components: {
    Field,
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {}
  },
  props: {
    errors: Object,
  },
  methods: {},

}
</script>
